import React, { useMemo } from "react";
import { Card, Row } from "antd";
import { useSelector } from "react-redux";
import DOMPurify from "dompurify";

const HotelCityResultContent = () => {
  const { data, error, loading } = useSelector((state) => state.seoHotelCity);

  const sanitizedDescription = useMemo(
    () => DOMPurify.sanitize(data?.description || ''),
    [data?.description]
  );

  if (loading) return <p>Loading...</p>;

  if (error) {
    return (

      <Row gutter={16} className="airport_content mt-5 mb-5 d-md-block d-none">
        <Card className="p-3">
          <section id="Error-Message">
            <p style={{ color: 'red' }}>{error.message || "Something went wrong"}</p>
          </section>
        </Card>
      </Row>
    );
  }

  if (!data?.city_name || !data?.description) return null;

  return (
    
    <Row gutter={16} className="airport_content mt-5 mb-5 d-md-block d-none">
      <Card className="p-3">
        <section id="From-City">
          <div>
            <h2>{data.city_name} {data.country_name}</h2>
            <div
              dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
            />
          </div>
        </section>
      </Card>
    </Row>
  );
};

export default HotelCityResultContent;
